export const EMPTY_DATE = Symbol('empty_date');
export const EMPTY_DATE_AND_TIME = Symbol('empty_date_and_time');
export const DATE_CHANGE_SUCCESS = 'DATE_CHANGE_SUCCESS';
export const DATE_CHANGE_EMPTY_DATE = 'DATE_CHANGE_EMPTY_DATE';
export const DATE_CHANGE_ERROR_INVALID = 'DATE_CHANGE_ERROR_INVALID';
export const DATE_CHANGE_ERROR_OUT_OF_RANGE = 'DATE_CHANGE_ERROR_OUT_OF_RANGE';
export const START_DATE_CHANGED = 'START_DATE_CHANGED';
export const END_DATE_CHANGED = 'END_DATE_CHANGED';
